"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageThree = void 0;
exports.pageThree = () => ({
    content: [
        {
            style: 'pageThreeTableText',
            layout: {
                hLineWidth(i, node) {
                    return 0;
                },
                vLineWidth(i, node) {
                    return 0;
                },
            },
            table: {
                widths: [250, 267],
                headerRows: 0,
                body: [
                    [
                        {
                            stack: [
                                'Test Doctor MD',
                                'Palmetto Physical Medicine (Anderson)',
                                '10 Financial Blvd',
                                'Anderson, SC 29621',
                                'Phone: (864) 437-8930',
                            ], style: { bold: true }
                        },
                        {
                            stack: [
                                {
                                    layout: {
                                        hLineWidth(i, node) {
                                            return 0;
                                        },
                                        vLineWidth(i, node) {
                                            return 0;
                                        },
                                    },
                                    table: {
                                        widths: [100, 100],
                                        headerRows: 1,
                                        body: [
                                            [
                                                { text: 'Date', style: { bold: true } },
                                                { text: 'Order Number', style: { bold: true, alignment: 'right' } },
                                            ],
                                            [{ text: '08/30/2018 11:25 AM' },
                                                { text: '10', style: 'rightAlign' },
                                            ],
                                        ],
                                    },
                                },
                                { image: 'barcodeImage.png', width: 100 },
                            ],
                            style: { bold: true, alignment: 'center' }
                        },
                    ],
                ],
            },
        },
        {
            style: 'pageThreeTableText',
            layout: {
                hLineWidth(i, node) {
                    return (i === 0 || i === node.table.body.length) ? 1 : 0;
                },
                vLineWidth(i, node) {
                    return (i === 0 || i === node.table.widths.length) ? 1 : 0;
                },
            },
            table: {
                headerRows: 1,
                widths: [525],
                body: [
                    [
                        { text: 'Billing Information', style: { bold: true } },
                    ],
                    [
                        {
                            stack: [
                                'Abbie A (DOB: 08/22/2018)',
                                'a',
                                'A SC 92068',
                                '(714) 733-3701',
                            ],
                        },
                    ],
                ],
            },
        },
        {
            // The layout below will map over the body and style the border width based on return value;
            layout: {
                hLineWidth(i, node) {
                    if (i === 4) {
                        return 1;
                    }
                    return (i === 0 || i === node.table.body.length) ? 1 : 0;
                },
                vLineWidth(i, node) {
                    return (i === 0 || i === node.table.widths.length) ? 1 : 0;
                },
            },
            style: 'pageThreeTableText',
            table: {
                headerRows: 1,
                widths: [415, 15, 80],
                body: [
                    [
                        { text: 'Item', style: { bold: true } },
                        { text: 'Qty', style: { bold: true, alignment: 'right' } },
                        { text: 'Amount', style: { bold: true, alignment: 'right' } },
                    ],
                    [{
                            stack: [
                                'Bupivilog Kit KIT',
                                { text: 'Rx #:22 NDC:76420-0720-01 Lot#: Exp: Invalid Date', style: 'RxRow' },
                            ],
                        },
                        { text: '1', style: 'rightAlign' },
                        { text: '$0.00', style: 'rightAlign' },
                    ],
                    [{
                            stack: [
                                'Bupivilog Kit KIT',
                                { text: 'Rx #:22 NDC:76420-0720-01 Lot#: Exp: Invalid Date', style: 'RxRow' },
                            ],
                        },
                        { text: '1', style: 'rightAlign' },
                        { text: '$0.00', style: 'rightAlign' },
                    ],
                    [{
                            stack: [
                                'Bupivilog Kit KIT',
                                { text: 'Rx #:22 NDC:76420-0720-01 Lot#: Exp: Invalid Date', style: 'RxRow' },
                            ],
                        },
                        { text: '1', style: 'rightAlign' },
                        { text: '$0.00', style: 'rightAlign' },
                    ],
                    ['', '', { stack: ['Total: $0.00', 'Payment: $0.00', 'Balance Due: $0.00'], style: { alignment: 'right' } }],
                ],
            },
        },
        // Patient Acknowledgement Table
        {
            style: 'pageThreeTableText',
            layout: {
                hLineWidth(i, node) {
                    return (i === 0 || i === node.table.body.length) ? 1 : 0;
                },
                vLineWidth(i, node) {
                    return (i === 0 || i === node.table.widths.length) ? 1 : 0;
                },
            },
            table: {
                headerRows: 1,
                widths: 'auto',
                body: [
                    ['Patient Acknowledgement'],
                    [
                        { text: 'By signing, patient acknowledges receipt of and instruction on the use ' +
                                'and contraindictions of the product(s) listed above. If payment has been ' +
                                'made by credit card, patient agrees to apy the above amount according to the ' +
                                'card ussuer agreement. Patient acknowledges medications may not be returned and ' +
                                'that all sales are final.',
                            style: 'acknowledgement',
                        },
                    ],
                    [{ text: 'Patient Signature: ____________________________________', style: 'signature' }],
                ],
            },
        },
    ],
    styles: {
        testWidth: {
            width: 100,
        },
        RxRow: {
            margin: [10, 0, 0, 0],
        },
        headerRow: {
            bold: true,
        },
        rightAlign: {
            alignment: 'right',
        },
        pageThreeTableText: {
            fontSize: 8,
            bold: false,
            margin: [-20, 15, 0, 0],
            alignment: 'left',
        },
        acknowledgement: {
            margin: [0, 5, 0, 40],
        },
        signature: {
            margin: [0, 0, 0, 10],
        },
    },
});



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/pdfs/thirdPage.ts
// module id = 2732
// module chunks = 0 1